export function normalizeFingerprint(message) {
    return (message
        .replace(/https?:\/\/[^\s'"]+/g, '<url>')
        .replace(/\b[0-9A-HJKMNP-TV-Z]{26}\b/g, '<ulid>')
        .replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi, '<uuid>')
        .replace(/[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g, '<email>')
        .replace(/(?<=^|\s)@[A-Za-z0-9_][A-Za-z0-9_.-]*(?![\w./-])/g, '@<handle>')
        .replace(/\d{8,}/g, '<num>')
        .slice(0, 200));
}
//# sourceMappingURL=posthog-fingerprint.js.map